export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "module_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de usuario"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambiar contraseña"])},
          "current_password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña actual"])},
          "new_password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva contraseña"])},
          "new_password_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmación de contraseña"])},
          "min_pass_length": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Longitud mínima de 6 caracteres"])},
          "min_one_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Debe contener por lo menos un número"])},
          "min_one_lower": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Debe contener por lo menos una minúscula"])},
          "min_one_upper": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Debe contener por lo menos una mayúscula"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}